import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import FinancialStatementFactory from "../../Entity/Factories/FinancialStatementFactory";;
import Constants from "../../Action/Constants";
import { FinancialStatementInterface } from "Casadesk/Entity/Entities/FinancialStatement/FinancialStatementInterface";

class FinancialStatementUpdate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const financialStatement: FinancialStatementInterface = FinancialStatementFactory.create(props.res)

    this.props.dispatch({
      type: Constants.FINANCIAL_STATEMENT_UPDATE_SUCCESS,
      payload: {
        financialStatement: financialStatement,
      }
    })

    this.props.dispatch({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_LIST_OUTDATE_REQUESTS,
    });
  }

}

export { FinancialStatementUpdate };
